import { useGetCreditsBalanceQuery } from '@/features/ai/creditsApi'
import { floorCredits, isPositiveCredits } from '@/features/ai/lib/money'
import { creditsShare } from '@/features/ai/lib/creditsShare'

/**
 * Баланс кредитов в том виде, в каком его печатает боковое меню: и строка под
 * именем в профиле, и карточка кредитов внутри меню берут цифры отсюда.
 */
export const useCreditsDisplay = () => {
  const { data: credits, isError } = useGetCreditsBalanceQuery()
  const balance = credits?.balance
  const held = isPositiveCredits(credits?.held) ? (credits?.held ?? null) : null
  // Ответ без суммы — не данные. `formatCreditsWithWord(undefined)` бросает, а
  // `ErrorBoundary` в приложении РОВНО ОДИН и стоит внутри редактора: бросок
  // отсюда белит не экран, а всё приложение. Тот же гвард, что у чипа шапки.
  const unavailable = isError || (credits !== undefined && !balance)
  // Что печатаем: обычно целую часть — «731.557 кредита» не помещается в
  // ширину сайдбара и переносится на две строки, а вверх округлять нельзя, это
  // обещало бы деньги, которых у автора нет. Точная сумма в одном клике: плашка
  // ведёт в окно кредитов.
  //
  // Исключение — остаток МЕНЬШЕ единицы: там округление вниз само заводит ложь,
  // «0 кредитов» над непустым счётом неотличимо от честного нуля. Такая строка
  // короткая и переноса не даёт, поэтому печатается точно.
  const shownBalance = !balance
    ? ''
    : isPositiveCredits(balance) && floorCredits(balance) === '0'
      ? balance
      : floorCredits(balance)

  // Доля остатка от последней покупки — для полоски точек; `null` — без полоски.
  const share = unavailable ? null : creditsShare(balance, credits?.lastPurchaseAmount)

  return { balance, held, unavailable, shownBalance, share }
}
